import { createContext} from 'react';

export const ChatDetailContext = createContext();